import { createContext, useContext, useState } from "react";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem("a4u_lang") || "en");
  const changeLang = (l) => {
    localStorage.setItem("a4u_lang", l);
    setLang(l);
  };
  return <LangContext.Provider value={{ lang, setLang: changeLang }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
